import 'react-awesome-slider/dist/styles.css';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Tooltip } from "react-tooltip";
import ScreenResize from '../ScreenResize/ScreenResize';
import React,{useEffect} from "react";
import normatecaStore from "../../../stores/normatecaStore";

export default function PublicacionesRecientes(){
   const imgurl = process.env.REACT_APP_IMG_URL + "normateca/"; 
   const nas = process.env.REACT_APP_NAS; 
   const screen= ScreenResize();
   const {setPublicRecientes,jsonPublicRecientes,setError} =
   normatecaStore((state) =>( { 
        setPublicRecientes: state.setPublicRecientes,
        jsonPublicRecientes: state.jsonPublicRecientes,
        setError:state.setError,
    })); 
    useEffect(() => {
         setPublicRecientes().then(function(data){
            if(data==="Error"){
                setError().catch(null);
            }
        })
     }, []);
    const settings = {
        dots: true,
        infinite: true,
        speed: 800,
        autoplaySpeed:7000,
        slidesToShow:screen.width<500? 1 : screen.width < 1000? 2: screen.width < 1268? 3 : 4,
        slidesToScroll: screen.width<500? 1 : screen.width < 1000? 2: screen.width < 1268? 3 : 4,
        autoplay: true,
      }
    return(
        <div>
            <div className="divTit">
                <div className="titpublicRes">Publicaciones recientes</div>
                <div className="linepublicRes"></div>
            </div>
            <div className=" divCarrusel">
            <Slider {...settings} >
               {jsonPublicRecientes?.map((l,index)=>(
                    <div  key={"jr" + index.toString()} >
                    <a href={nas + l.nombre_Archivo} className="aLeer" target="_blank" rel="noreferrer">

                        <div className="leyendaPR">
                            {/* <div className="tipoLey" >{l.descripcion}</div> */}
                            <div className="divTitLeer">
                                {l.nombre_Disposicion.length>80?
                                    <>
                                    <div className="txtEllipsis" data-tooltip-id="my-tooltip"  data-tooltip-content={l.nombre_Disposicion}  data-tooltip-place="top">
                                        {l.nombre_Disposicion}
                                    </div>
                                    <Tooltip id="my-tooltip" className="tooltip"/>
                                    </>
                                :
                                    <div className="txtEllipsisSin">
                                        {l.nombre_Disposicion}
                                    </div>
                                }
                                <div className="display-flex ">
{/*                                     <a href={nas + l.nombre_Archivo} className="aLeer" target="_blank" rel="noreferrer">
 */}                                    <div className="width-15 display-flex aLeer">Leer
                                        <div className="rotate90 leerFlecha"><span className="inegi-asc"></span></div></div>
                                   
                                    <div className="leerFecha">{l.fecha_Publica_Normateca}</div></div>
                            </div>
                          </div>
                        </a>
                        <div>
                            <img src={imgurl + l.img} className="width-15-4rem" />
                        </div>
                    </div>
                ))}
            </Slider>
          </div>
        </div>
    )

}